// extracted by mini-css-extract-plugin
export default {"frontside":"CardFront-module--frontside--3WfKY"};